export function reduceDataSets(dataSets) {
  const reducedData = {};
  dataSets.forEach((dataSet) => {
    dataSet.forEach((dataPoint) => {
      const { time, ...rest } = dataPoint;
      if (!reducedData[time]) {
        reducedData[time] = { time, ...rest };
      } else {
        for (const key in rest) {
          if (rest.hasOwnProperty(key)) {
            reducedData[time][key] += rest[key];
          }
        }
      }
    });
  });

  return Object.values(reducedData);
}
